import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Routes } from '../../../../data/Routes';
import MenuItem from '../../MenuItem/MenuItem';
import { ApplicationContext } from '../../../../ApplicationContext';

/**
 *
 */
class CompanySettingsSubMenu extends React.Component {
	/**
	 *
	 */
	constructor(props) {
		super(props);

		// eslint-disable-next-line react/no-unused-class-component-methods
		this.menu = null;
	}

	/**
	 *
	 * @returns {*}
	 */
	render() {
		const { applicationStore } = this.context;
		if (!applicationStore.isLoggedIn) {
			return null;
		}

		const company = applicationStore.getSelectedCompany(true);

		return (
			<ul className="sub-menu__item-wrapper">
				<MenuItem
					className="submenu-item"
					route={Routes.COMPANY_SETTINGS_INFO.getPath({ id: company.id })}
					routeToMatch={Routes.COMPANY_SETTINGS_INFO}
					matchExact
					iconName="home">
					<FormattedMessage id="settings.submenu.company.info" />
				</MenuItem>
				<MenuItem
					className="submenu-item"
					route={Routes.COMPANY_SETTINGS_INVOICES.getPath({ id: company.id })}
					routeToMatch={Routes.COMPANY_SETTINGS_INVOICES}
					matchExact
					iconName="file">
					<FormattedMessage id="settings.submenu.company.invoicesettings" />
				</MenuItem>
				<MenuItem
					className="submenu-item"
					route={Routes.COMPANY_SETTINGS_OFFERS.getPath({ id: company.id })}
					routeToMatch={Routes.COMPANY_SETTINGS_OFFERS}
					matchExact
					iconName="pen">
					<FormattedMessage id="settings.submenu.company.offersettings" />
				</MenuItem>
				<MenuItem
					className="submenu-item"
					route={Routes.COMPANY_SETTINGS_COMMUNITY_PROFILE.getPath({
						id: company.id,
						profileId: 'edit'
					})}
					routeToMatch={Routes.COMPANY_SETTINGS_COMMUNITY_PROFILE}
					matchExact
					iconName="tag">
					<FormattedMessage id="settings.submenu.company.profile" />
				</MenuItem>
			</ul>
		);
	}
}

CompanySettingsSubMenu.contextType = ApplicationContext;

CompanySettingsSubMenu.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired
	})
};

export default withRouter(CompanySettingsSubMenu);
